import script from "./HalfSphere.vue?vue&type=script&setup=true&lang=js"
export * from "./HalfSphere.vue?vue&type=script&setup=true&lang=js"

import "./HalfSphere.vue?vue&type=style&index=0&id=612da4a5&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-612da4a5"]])

export default __exports__